import { seo } from "@/utils/seo";
import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";
import { fallback, object, optional, string } from "valibot";

export const Route = createFileRoute("/sign-in")({
  component: lazyRouteComponent(() => import("./+SignIn")),
  validateSearch: object({
    to: fallback(optional(string()), undefined),
  }),
  head: () => ({
    meta: seo({ title: "Sign in" }),
  }),
});
